import React from 'react';

const ReportsContext = React.createContext();

export default ReportsContext;
